module.exports = __webpack_public_path__ + "img/calendar.3623acd4.svg";